import { isEmpty, isNotEmpty } from '@/shared/util';

export function parseHtmlDocument(html: string): Document {
  return new DOMParser().parseFromString(html, 'text/html');
}

function isIgnorableElementBetweenLists(element: Element): boolean {
  if (element.tagName === 'BR') {
    return true;
  }

  if (element.tagName === 'P' || element.tagName === 'SPAN') {
    return isEmpty(element.textContent) && !element.querySelector('img');
  }

  return false;
}

export function areNearbyListBlocks(first: Element, second: Element): boolean {
  let node: ChildNode | null = first.nextSibling;

  while (node) {
    if (node === second) {
      return true;
    }

    if (node.nodeType === Node.ELEMENT_NODE && !isIgnorableElementBetweenLists(node as Element)) {
      return false;
    }

    node = node.nextSibling;
  }

  return false;
}

export function cloneListItemContent(listItem: HTMLLIElement): DocumentFragment {
  const fragment = document.createDocumentFragment();

  for (const child of Array.from(listItem.childNodes)) {
    if (child.nodeType === Node.ELEMENT_NODE) {
      const element = child as Element;

      // Nested lists are represented as sibling indent items in Quill, not child <ul>/<ol>.
      if (element.tagName === 'UL' || element.tagName === 'OL') {
        continue;
      }
    }

    fragment.appendChild(child.cloneNode(true));
  }

  return fragment;
}

export function hasListItemContent(listItem: HTMLLIElement): boolean {
  const fragment = cloneListItemContent(listItem);
  const container = document.createElement('div');

  container.appendChild(fragment);

  return isNotEmpty(container.textContent) || Boolean(container.querySelector('img, br'));
}

export function serializeNormalizedRoot(root: ParentNode): string {
  if (root instanceof HTMLElement) {
    return root.innerHTML;
  }

  const serializer = new XMLSerializer();

  return Array.from(root.childNodes)
    .map((node) => serializer.serializeToString(node))
    .join('');
}
